import { render } from "./form_user_client_role.vue?vue&type=template&id=70a3eb63"
import script from "./form_user_client_role.vue?vue&type=script&lang=js"
export * from "./form_user_client_role.vue?vue&type=script&lang=js"

import exportComponent from "/home/deployer/asset-portal/releases/20260828153143/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__